import progress from 'nprogress'
import 'nprogress/nprogress.css'

progress.configure({
  showSpinner: true,
})

export default progress
